import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ResponsiveIframeContent } from './responsive-iframe.content';
import { isNumeric } from '../../../_helpers/util';

@Component({
  selector: 'app-responsive-iframe',
  templateUrl: './responsive-iframe.component.html',
  styleUrls: ['./responsive-iframe.component.scss'],
})
export class ResponsiveIframeComponent
  implements AfterViewInit, OnChanges {

  @Input() content = '';
  @Input() minHeight: number | string = -1;

  @ViewChild('iframe', { static: true })
  iframeRef!: ElementRef<HTMLIFrameElement>;

  private iframeReady = false;

  ngAfterViewInit(): void {
    this.iframeReady = true;
    this.writeContent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content'] && this.iframeReady) {
      this.writeContent();
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.resizeIframe();
  }

  private writeContent(): void {
    const iframe = this.iframeRef.nativeElement;
    const doc = iframe.contentDocument;

    if (!doc) return;

    doc.open();
    doc.write(ResponsiveIframeContent.getIframeContentTemplate(this.content));
    doc.close();

    // Aguarda layout final (fonts, imagens)
    requestAnimationFrame(() => this.resizeIframe());
  }

  private resizeIframe(): void {
    const iframe = this.iframeRef.nativeElement;
    const doc = iframe.contentDocument;

    if (!doc) return;

    // 🔑 reset obrigatório
    iframe.style.height = '0px';
    void iframe.offsetHeight;

    const height = Math.ceil(
      Math.max(
        doc.body.scrollHeight,
        doc.documentElement.scrollHeight,
        doc.body.offsetHeight,
        doc.documentElement.offsetHeight,
      ),
    );

    if (this.minHeight === -1) {
      iframe.style.height = `${height}px`;
    } else if (isNumeric(this.minHeight)) {
      iframe.style.height = `max(${this.minHeight}px, ${height}px)`;
    } else {
      iframe.style.height = `max(${this.minHeight}, ${height}px)`;
    }
  }
}
